import { useSalesServiceSalesCashBoxesListKey } from '@insurance/api/queries'
import { SalesService } from '@insurance/api/requests'
import { InfiniteSelect } from '@shared/components'
import { SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = { available?: boolean; activeOnly?: boolean } & SelectProps

export const CashBoxSelect = ({ available, activeOnly, ...props }: Props) => {
  const { t } = useTranslation()

  return (
    <InfiniteSelect
      placeholder={t('select_cash_box')}
      apiCall={({ pageParam, pageSize, search }) =>
        SalesService.salesCashBoxesList(
          typeof activeOnly === 'boolean' ? String(activeOnly) : undefined,
          typeof available === 'boolean' ? String(available) : undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          pageParam,
          pageSize,
          search
        )
      }
      queryKey={[
        useSalesServiceSalesCashBoxesListKey,
        { available, activeOnly }
      ]}
      getOption={({ name, id }) => ({
        label: name,
        value: String(id)
      })}
      style={{ minWidth: 200 }}
      {...props}
    />
  )
}
